import { TextButton, typography } from "@joor/design-system";
import styled from "styled-components";

export const SummaryBarContent = styled.div`
  :first-child {
    border-right: 1px solid var(--color-primary-100);
  }
  :not(:first-child) {
    border-right: 1px solid var(--color-primary-100);
  }
`;

export const StyledContent = styled.div`
  display: inline-flex;
  flex-direction: column;
  justify-items: center;
  padding-right: 40px;
  :not(:last-child) {
    padding-right: 40px;
  }
  :last-child {
    padding-right: 20px;
  }
`;

export const StyledLabel = styled.div`
  ${typography.alpha.primaryActive.body3};
  color: var(--color-primary-600);
  align-items: center;
  display: flex;
  text-align: left;
  line-height: 16px;
  margin-bottom: 4px;
`;

export const StyledTitle = styled.div`
  ${typography.alpha.primaryActive.subtitle3};
  align-items: left;
  display: flex;
  flex-direction: row;
  gap: 5.5px;
  letter-spacing: 1px;
  line-height: 16px;
  text-align: left;
  margin-bottom: 4px;
`;

export const StyledMenu = styled.div`
  position: absolute;
  background-color: var(--color-neutral-000-full);
  border-radius: var(--size-border-radius-small);
  border: none;
  box-shadow: var(--elevation-4);
  z-index: 30;
`;

export const StyledMenuOptions = styled.div`
  margin: 10px;
`;

export const StyledSummaryBar = styled.header`
  display: flex;
  padding: 2px 20px 2px 20px;
  border-bottom: 1px solid var(--color-primary-100);
`;

export const SummaryBarSection = styled.div`
  display: flex;
  gap: 20px;
  padding-block: 5.5px;
  overflow-x: auto;
  white-space: nowrap;
`;

export const StyledTextButtonWrapper = styled.div`
  position: relative;
  width: 130px;
`;

export const StyledTextButton = styled(TextButton)`
  position: absolute;
  bottom: 6px;
  right: 1px;
`;

export const StyledFinancialsButton = styled(TextButton)`
  width: max-content;
`;

export const FinancialColumn = styled.div`
  display: inline-flex;
  flex-direction: column;
`;

export const ButtonColumn = styled.div`
  display: inline-flex;
  padding-left: 8px;
  padding-bottom: 2px;
  flex-direction: column;
  justify-content: flex-end;
`;

export const extraRows = (numCurrencies: number) => {
  const elem = [];
  for (var i = 0; i < numCurrencies - 1; i++) {
    elem.push(
      <StyledTitle style={{ visibility: "hidden" }}>extraRow</StyledTitle>
    );
  }
  return elem;
};
